import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { Loader2, ShieldCheck, Briefcase, Users, ChevronDown, ChevronUp} from 'lucide-react';
import { EFFECTIF_OPTIONS} from './eligibilityHelpers';
import useEligibilityProfile from './useEligibilityProfile';
import EligibilityPreventionSection from './EligibilityPreventionSection';
import EligibilityMarketSection from './EligibilityMarketSection';

export default function EligibilityProfilePanel(props) {
  const ctx = useEligibilityProfile(props);
  const {
    AUTO_TYPES, accidentsCoutTotal, accidentsList, accidentsTravail, ancienneteAnnees, collapsed,
    config, effectif, experienceAnnees, loading, prefilledForMembreRef, pvReception,
    pvReceptionFiles, qualifications, referencesTravauxFiles, setAccidentsList, setAccidentsTravail, setAncienneteAnnees,
    setCollapsed, setConfig, setEffectif, setExperienceAnnees, setLoading, setPvReception,
    setPvReceptionFiles, setQualifications, setReferencesTravauxFiles, setSinistralitDate, setSinistralitFiles, setSinistresAnterieurs,
    setTerritoiresCA, setTypeMarche, setVentClientele, setVentContrat, setVentTravaux, sinistralitDate,
    sinistralitFiles, sinistresAnterieurs, territoireCATotal, territoiresCA, toggleQualif, typeMarche,
    uploadJustificatif, ventClientele, ventContrat, ventTravaux, membre, isSuperAdmin,
    nombreActivites} = ctx;

  if (loading || !config) {
    return (
      <Card className="border-slate-200" data-testid="eligibility-profile-panel-loading">
        <CardContent className="py-6 text-sm text-slate-500 flex items-center justify-center">
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          Chargement du profil d&apos;éligibilité…
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-2 border-indigo-100 bg-gradient-to-br from-white to-indigo-50/30" data-testid="eligibility-profile-panel">
      <CardHeader className="pb-3 cursor-pointer" onClick={() => setCollapsed((c) => !c)}>
        <div className="flex items-start justify-between">
          <div>
            <CardTitle className="text-base flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-indigo-600" />
              Profil d&apos;éligibilité RCDS BATICO
            </CardTitle>
            <CardDescription className="mt-1 text-xs">
              Affine la tarification selon votre expérience, qualifications et activité.
              {qualifications.length > 0 && <> {qualifications.length} qualification(s) cochée(s).</>}
            </CardDescription>
          </div>
          <Button variant="ghost" size="sm" aria-label="Toggle">
            {collapsed ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
          </Button>
        </div>
      </CardHeader>

      {!collapsed && (
        <CardContent className="space-y-5">
          {/* Expérience + Ancienneté + Effectif */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div>
              <Label className="text-xs font-semibold text-slate-700 flex items-center gap-1.5">
                <Briefcase className="h-3 w-3" /> Expérience pro (années)
              </Label>
              <Input
                type="number" min="0" max="60"
                value={experienceAnnees}
                onChange={(e) => setExperienceAnnees(e.target.value)}
                placeholder="Ex: 8"
                className="h-9 mt-1 text-sm"
                data-testid="experience-annees-input"
              />
            </div>
            <div>
              <Label className="text-xs font-semibold text-slate-700">Ancienneté entreprise (années)</Label>
              <Input
                type="number" min="0" max="100"
                value={ancienneteAnnees}
                onChange={(e) => setAncienneteAnnees(e.target.value)}
                placeholder="Ex: 5"
                className="h-9 mt-1 text-sm"
                data-testid="anciennete-annees-input"
              />
              {(membre?.date_creation_entreprise || membre?.date_creation) && (
                <p className="text-[10px] text-slate-400 mt-0.5">Pré-rempli depuis SIRET</p>
              )}
            </div>
            <div>
              <Label className="text-xs font-semibold text-slate-700 flex items-center gap-1.5">
                <Users className="h-3 w-3" /> Effectif
              </Label>
              <select
                value={effectif}
                onChange={(e) => setEffectif(e.target.value)}
                className="w-full h-9 mt-1 rounded-md border border-slate-200 px-3 text-sm bg-white"
                data-testid="effectif-select"
              >
                {EFFECTIF_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>
          </div>
          <EligibilityPreventionSection {...ctx} />
          <EligibilityMarketSection {...ctx} />
        </CardContent>
      )}
    </Card>
  );
}
